import { render, staticRenderFns } from "./RegistryCaseGrid.vue?vue&type=template&id=1caf96c6&"
import script from "./RegistryCaseGrid.vue?vue&type=script&lang=js&"
export * from "./RegistryCaseGrid.vue?vue&type=script&lang=js&"
import style0 from "./RegistryCaseGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports